var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error"},[_vm._v(" URLの有効期限が切れました。 ")])}
var staticRenderFns = []

export { render, staticRenderFns }